/**
 * author: Soumya Shreyas
 * Choose Document Modal
 */

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Breadcrumb, Button, Modal } from "react-bootstrap";
import { FcFolder } from "react-icons/fc";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import RiskConfigService from "../../core/service/RiskConfigService";
import DmsService from "../../core/service/DmsService";
import FolderBreadcrumb from "./FolderBreadcrumb/FolderBreadcrumb";
import Folder from "./Folder/Folder";
// import "./DocumentModal.scss";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";

export const ROOT_FOLDER = { name: "Folders", id: null };

function DocumentModal({ t, modalObj, callbackModal }) {
  const [show, setShow] = useState(modalObj.isShow);
  const [folderName, setFolderName] = useState("");
  const [showNewFolder, setShowNewFolder] = useState(false);
  const [directory, setDirectory] = useState([]);
  const [parentId, setParentId] = useState("");
  const [regId, setRegId] = useState(modalObj?.regulation?.id ? modalObj?.regulation?.id : "");
  const [currentFolder, setCurrentFolder] = useState([
    { id: "0", name: t("Documents.label") },
  ]);
  const [selDoc, setSelDoc] = useState("");
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [selFolderName, setSelFolderName] = useState("");
  const folderId = null;
  //console.log("currentFolder",currentFolder);
  useEffect(() => {
    if (regId) {
      let obj = { id: modalObj?.regulation?.id, name: modalObj?.regulation?.name };
      setCurrentFolder([...currentFolder, obj]);
      getSubFolders(regId, folderId);
    } else if (folderId === null) {
      getRegulations();
    }
  }, [folderId]);
  const getRegulations = () => {
    setRegId("");
    RiskConfigService.getRegulations()
      .then((response) => {
        setDirectory([...response.data]);
      })
      .catch((error) => {
      });
  };

  const getSubFolders = (regulation, parentId = "") => {
    DmsService.getRegulationDoc(regulation, parentId)
      .then((response) => {
        setDirectory([...response.data]);
      })
      .catch((error) => { });
    setDirectory([]);
  };
  const handleClose = () => {
    setShow(false);
    let obj = {
      isClose: true,
    };
    callbackModal(obj);
  };
  const handleConfirm = () => {
    setShow(false);
    let obj = {
      isClose: true,
    };
    callbackModal(obj);
  };
  const callbackBreadCrumb = (index, folderId) => {
    index === 0
      ? getRegulations()
      : index === 1
        ? getSubFolders(folderId)
        : getSubFolders(regId, folderId);

    let data = [...currentFolder];
    let parent = index > 1 ? data[index - 1].id : "";
    setParentId(parent);
    data.length = index + 1;
    setCurrentFolder(data);
  };
  const callbackFolder = (callbackObj) => {
    const id = callbackObj.id;
    const folderName = callbackObj.folderName;
    setSelFolderName(folderName);
    if (callbackObj.type === 1) {
      setSelDoc(callbackObj.isDoc ? id : "");
    } else if (callbackObj.type === 2) {
      let obj = { id: id, name: folderName };
      setCurrentFolder([...currentFolder, obj]);
      if (!regId) {
        setRegId(id);
        getSubFolders(id, "");
      } else {
        setParentId(id);
        getSubFolders(regId, id);
      }
    }
  };
  const handleCreate = (e) => {
    e.preventDefault();
    var params;
    if (parentId) {
      params = {
        name: folderName,
        container: {
          id: parentId,
        },
      };
    } else {
      params = {
        name: folderName,
      };
    }
    DmsService.createRegulationDoc(regId, params)
      .then((response) => {
        if (response.status === 201) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setFolderName("");
          getSubFolders(regId, parentId);
        }
      })
      .catch((error) => {
        setFolderName("");
        // if (error?.response?.status === 400) {
        // } else {
        //   toast.error(error?.response?.data?.message, {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
        // }
      });
  };
  //   const callbackDeleteFolder = (item) => {
  //     item?.container?.id &&   getSubFolders(item.container.id);

  //   };
  const handleSelect = () => {
    if (regId && selDoc) {
      setShow(false);
      let obj = {
        isClose: true,
        selFolder: selDoc,
        path: currentFolder,
        selectedFolderName: selFolderName,
      };
      callbackModal(obj);
    } else {
      setShowMessageModal(true);
    }
  };
  const callbackMessageModal = (val) => {
    setShowMessageModal(false);
  };
  const callbackDeleteFolder = (item) => {
    item?.container?.id ? getSubFolders(regId, item.container.id) : getSubFolders(regId);

  };
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        className="Choose_Docu_modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
         <Modal.Title as="h5">{t("NewSharedFolder.label")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="Choose_Docu_sliderbar">
            <ul>
              <li>
                <Link to="#" className="active">
                  {t("AllDocuments.label")}
                </Link>
              </li>
              {/* <li>
                <Link to="#">{t("Recent.label")} </Link>
              </li> */}
            </ul>
          </div>
          <div className="Choose_Docu_Body p-2">
            <div>
              {currentFolder.length > 1 && (
                <FolderBreadcrumb
                  currentFolder={currentFolder}
                  callbackBreadCrumb={callbackBreadCrumb}
                />
              )}
            </div>
            <div className="DMSFiles_folderBox">
              {directory?.map((dir) => (
                <Folder
                  folder={dir}
                  callbackFolder={callbackFolder}
                  deleteFolder={callbackDeleteFolder}
                  regulation={regId}
                  key={dir.id}
                />
              ))}
            </div>
          </div>

          {modalObj.action === "Create" ? (
            <div className="Choose_Docu_footer  ">
              <span className="white-space py-1 px-2"> {t("FolderName.label")}</span>
              <input
                type="text"
                className="form-control"
                value={folderName}
                onChange={(e) => setFolderName(e.target.value)}
              />
              <div className="px-2">
                <Button
                  variant="primary"
                  className="px-4"
                  onClick={handleCreate}
                >
                  {t("Create.label")}
                </Button>
              </div>
            </div>
          ) : (
            <div className="Choose_Docu_footer text-end">
              {/* <Button
                variant="secondary"
                className="px-3"
                onClick={handleClose}
              >
                {t("AddFolder.label")}
              </Button> */}
              <div className=" text-end">
                <Button
                  variant="secondary"
                  className="me-2 px-3"
                  onClick={handleClose}
                >
                  {t("Cancel.label")}
                </Button>
                <Button
                  variant="primary"
                  className="px-4"
                  onClick={handleSelect}
                >
                  {t("Select.label")}
                </Button>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
      {showMessageModal && (
        <ConfirmationModal
          modalShow={true}
          messageText={
            regId
              ? t("DocumentModalPleasetSelectText.label")
              : t("DocumentModalCannotSelectRootText.label")
          }
          callbackModal={callbackMessageModal}
        />
      )}
    </>
  );
}

export default withTranslation()(DocumentModal);
